import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from 'primereact/button';
import GlobalTable from '../components/GlobalTable';
import { useLazyTable } from '../hooks/useLazyTable';
import axiosInstance from '../services/axiosInstance';
import { handleApiError } from '../components/apiErrorHandler';
import { useBreadcrumbs } from '../contexts/BreadcrumbContext';

const CustomerPayments = () => {
  const [payments, setPayments] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { lazyParams, onPage, onSort, onFilter, queryParams } = useLazyTable({ rows: 15 });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { push, beginDrilldown } = useBreadcrumbs();

  const loadPayments = () => {
    setLoading(true);
    axiosInstance
      .get('/api/payments/', { params: queryParams })
      .then(res => {
        setPayments(res.data.results || []);
        setTotalRecords(res.data.count || 0);
      })
      .catch(handleApiError)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadPayments();
  }, [queryParams]);

  const columns = [
    { Header: 'Payment #', accessor: 'id', filtered: true },
    {
      Header: 'Customer',
      accessor: 'customer_name',
      filtered: true,
      bodyTemplate: (rowData) => (
        <span
          style={{ color: '#2563eb', cursor: 'pointer' }}
          onClick={() => {
            beginDrilldown();
            navigate(`/customers/${rowData.customer_id}`);
            push({
              label: 'Customer Payments',
              path: '/customer-payments'
            });
            push({
                label: `Customer: ${rowData.customer_name}`,
                path: `/customers/${rowData.customer_id}`,
            });
          }}
        >
          {rowData.customer_name}
        </span>
      )
    },
    {
      Header: 'Invoice #',
      accessor: 'invoice_number',
      filtered: true,
      bodyTemplate: (rowData) => (
        <span
          style={{ color: '#2563eb', cursor: 'pointer' }}
          onClick={() => {
            beginDrilldown();
            navigate('/invoices', {
              state: { invId: rowData.invoice }
            });
            push({
              label: 'Customer Payments',
              path: '/customer-payments'
            });
            push({
              label: `Invoices`,
              path: '/invoices',
            });
            push({
              label: `Invoice: ${rowData.invoice_number}`,
              path: '/invoices',
              state: { invId: rowData.invoice }
            });
          }}
        >
          {rowData.invoice_number}
        </span>
      )
    },
    { Header: 'Amount', accessor: 'amount', dataType: 'currency' },
    { Header: 'Payment Date', accessor: 'date', dataType: 'date' },
    { Header: 'Pay Method', accessor: 'method', filtered: true },
    { Header: 'Status', accessor: 'status', filtered: true },
  ];

  return (
    <div className="containers">
      <GlobalTable
        columns={columns}
        data={payments}
        loading={loading}
        tabletitle="Customer Payments"
        showEditColumn={false}
        lazy
        totalRecords={totalRecords}
        lazyParams={lazyParams}
        onPage={onPage}
        onSort={onSort}
        onFilter={onFilter}
        headerAction={
          <Button icon="pi pi-refresh" label="Refresh" outlined onClick={loadPayments} />
        }
      />
    </div>
  );
};

export default CustomerPayments;